import { environment } from 'environments/environment';

import { PermissionType } from '@shared/models/enums/permission-type.enum';
import { AuthService } from '@shared/services';
import { hasCompanyPermission } from '@shared/utils';

import { SideMenuItem } from './menu-item';

export function getCompanyMenu(authService: AuthService): SideMenuItem[] {
  return [
    {
      label: 'layout.menu.company',
      items: [
        {
          label: 'layout.menu.companyDashboard',
          icon: 'pi pi-fw pi-briefcase',
          routerLink: ['/app', 'dashboard'],
          visible: hasCompanyPermission('company_dashboard', PermissionType.view, authService),
        },
        ...(environment.production
          ? []
          : [
              {
                label: 'layout.menu.processes',
                icon: 'pi pi-fw pi-sitemap',
                routerLink: ['/app', 'processes'],
                visible: hasCompanyPermission('company_processes', PermissionType.view, authService),
                badge: 'layout.menu.previewBadge',
              },
            ]),
        {
          label: 'layout.menu.instructions',
          icon: 'pi pi-fw pi-file',
          routerLink: ['/app', 'instructions'],
          visible: hasCompanyPermission('company_instructions', PermissionType.view, authService),
        },
      ],
    },
    {
      label: 'layout.menu.masterData',
      items: [
        {
          label: 'layout.menu.instructionTemplates',
          icon: 'pi pi-fw pi-file-edit',
          routerLink: ['/app', 'instruction-templates'],
          visible: hasCompanyPermission('company_instructionTemplates', PermissionType.view, authService),
        },
        {
          label: 'layout.menu.pictograms',
          icon: 'pi pi-fw pi-images',
          routerLink: ['/app', 'pictograms'],
          visible: hasCompanyPermission('company_pictograms', PermissionType.view, authService),
        },
        {
          label: 'layout.menu.referenceData',
          icon: 'pi pi-fw pi-list',
          routerLink: ['/app', 'reference-data'],
          visible: hasCompanyPermission('company_referenceData', PermissionType.view, authService),
        },
      ],
    },
    {
      label: 'layout.menu.administration',
      items: [
        {
          label: 'layout.menu.display',
          icon: 'pi pi-fw pi-desktop',
          routerLink: ['/app', 'display-settings'],
          visible: hasCompanyPermission('company_displaySettings', PermissionType.view, authService),
        },
        {
          label: 'layout.menu.globalConfiguration',
          icon: 'pi pi-fw pi-sliders-h',
          routerLink: ['/app', 'global-configuration'],
          visible: hasCompanyPermission('company_globalConfiguration', PermissionType.view, authService),
        },
        {
          label: 'layout.menu.usersAndAccess',
          icon: 'pi pi-fw pi-users',
          routerLink: ['/app', 'users'],
          visible: hasCompanyPermission('company_users', PermissionType.view, authService),
        },
        {
          label: 'layout.menu.company',
          icon: 'pi pi-fw pi-building',
          routerLink: ['/app', 'settings', 'company'],
          visible: hasCompanyPermission('company_data', PermissionType.view, authService),
        },
        ...(environment.airGap
          ? []
          : [
              {
                label: 'layout.menu.companySubscription',
                icon: 'pi pi-fw pi-credit-card',
                routerLink: ['/app', 'settings', 'company-subscription'],
                visible: hasCompanyPermission('company_subscription', PermissionType.view, authService),
              },
            ]),
        {
          label: 'layout.menu.dataAudit',
          icon: 'pi pi-fw pi-history',
          routerLink: ['/app', 'audit'],
          visible: hasCompanyPermission('company_dataAudit', PermissionType.view, authService),
        },
        // TODO (Denis): For now developer module is only exposed internally
        ...(environment.production
          ? []
          : [
              {
                label: 'layout.menu.developer',
                icon: 'pi pi-fw pi-code',
                routerLink: ['/app', 'developer'],
                visible: hasCompanyPermission('company_developer', PermissionType.view, authService),
                badge: 'layout.menu.previewBadge',
              },
            ]),
      ],
    },
  ];
}
